import type {
  CurrentUserProfile,
  UserProfileOptions,
  UserRef,
} from "@/types/user"

import userSlice from "@/lib/storage/user-slice"
import type {
  VoiceInterviewFlow,
  VoiceInterviewOptionsResponse,
} from "@/lib/voice-api"
import { baseApi } from "./base-api"

interface VoiceInterviewOptionsArgs {
  flow: VoiceInterviewFlow
  chatId?: number
}

export const profileSetupApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentUserProfile: builder.query<CurrentUserProfile, UserRef>({
      query: () => ({ url: "/api/user_profile/current" }),
      async onQueryStarted(_userRef, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(userSlice.actions.setUserProfile(data))
        } catch {
          // Leave existing profile state unchanged when loading fails.
        }
      },
    }),
    getProfileSetupOptions: builder.query<UserProfileOptions, void>({
      query: () => ({ url: "/api/user_profile/options" }),
      keepUnusedDataFor: 300,
    }),
    getVoiceInterviewOptions: builder.query<
      VoiceInterviewOptionsResponse,
      VoiceInterviewOptionsArgs
    >({
      query: ({ flow, chatId }) => ({
        url: "/api/voice/interview_options",
        params: { flow, chat_id: chatId },
      }),
      keepUnusedDataFor: 300,
    }),
  }),
})

export const {
  useGetCurrentUserProfileQuery,
  useGetProfileSetupOptionsQuery,
  useGetVoiceInterviewOptionsQuery,
  useLazyGetVoiceInterviewOptionsQuery,
} = profileSetupApi
